/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface SingleProductMedia
 */
export interface SingleProductMedia {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleProductMedia
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SingleProductMedia
     */
    file: string;
    /**
     * 
     * @type {string}
     * @memberof SingleProductMedia
     */
    type: SingleProductMediaTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SingleProductMedia
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof SingleProductMedia
     */
    order: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SingleProductMediaTypeEnum {
    Image = 'image',
    Video = 'video',
    Audio = 'audio'
}

